var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.selectedNeighborhoodIds && _vm.selectedNeighborhoodIds.length)?_c('nav',{staticClass:"breadcrumb mobhide",attrs:{"aria-label":"Breadcrumb"}},[_c('a',_vm._g({class:[{ 'pointer-none': _vm.isKioskMode }, 'breadcrumb-item']},
    !_vm.isKioskMode
      ? { click: () => _vm.breadCrumbsNavigation(_vm.communityUrl) }
      : null
  ),[_vm._v("Communities"),_c('span')]),_c('p',{staticClass:"breadcrumb-item not-clickable"},[_vm._v(_vm._s(_vm.communityName))]),_c('a',_vm._g({staticClass:"breadcrumb-item"},
    !_vm.isKioskMode
      ? { click: () => _vm.breadCrumbsNavigation(_vm.selectedNeighborhoodData.neighborhood_url) }
      : null
  ),[_vm._v(_vm._s(_vm.selectedNeighborhoodData.neighborhood_name))]),_c('span',{staticClass:"breadcrumb-item"},[_vm._v("Home Sites")])]):_c('nav',{staticClass:"breadcrumb mobhide",attrs:{"aria-label":"Breadcrumb"}},[_c('a',_vm._g({class:[{ 'pointer-none': _vm.isKioskMode }, 'breadcrumb-item']},
    !_vm.isKioskMode
      ? { click: () => _vm.breadCrumbsNavigation(_vm.communityUrl) }
      : null
  ),[_vm._v("Communities")]),_c('p',{staticClass:"breadcrumb-item not-clickable"},[_vm._v(_vm._s(_vm.communityName))]),_c('span',{staticClass:"breadcrumb-item"},[_vm._v("Home Sites")])])
}
var staticRenderFns = []

export { render, staticRenderFns }